import { useMemo } from "react";
import { useGetLabel } from "services/labels";

export const useIsUserBanned = () => {
  const label = useGetLabel();

  const isBanned = useMemo(
    () => label.data?.labelStatus === 5,
    [label.data?.labelStatus],
  );

  return {
    isBanned,
    labelStatus: label.data?.labelStatus,
    isLoading: label.isLoading,
    isError: label.isError,
  };
};
